import { useDispatch } from 'react-redux';
import {
  clearIncidentPopups,
  resetIncident,
} from '~/actions';
import { Typography } from '@tempmee/react';
import { ConfirmPopupContent } from '~/components/shared/ConfirmPopupContent';
import WarningIcon from '~/images/warning-icon.svg';
import { incidentTypes } from '../utils/incidentPopupUtil';

export const ConfirmationIncident = ({ incidentType, data, onSubmit }) => {
  const dispatch = useDispatch();

  return (
    <ConfirmPopupContent
      Icon={() => (
        <img
          src={WarningIcon}
          style={{ marginBottom: 20 }}
          alt="warning_icon"
          data-cy="confirm-incident-warning-icon"
        />
      )}
      title={incidentType === incidentTypes.noShow ? 'Report a No-Show' : 'Report a Walked Out'}
      description={
        <Typography as="span" textAlign="center" data-cy="confirm-incident-message" style={{ marginBottom: -40 }}>
          Are you sure you would like to report{' '}
          <strong data-cy="confirm-incident-professional-name">{data?.professionalName}</strong> as
          a {incidentType}?
        </Typography>
      }
      leftButtonAction={() => {
        dispatch(clearIncidentPopups());
        dispatch(resetIncident());
      }}
      leftButtonText="Cancel"
      leftButtonDataCy="confirm-incident-cancel-button"
      rightButtonAction={onSubmit}
      rightButtonText="Continue"
      rightButtonDataCy="confirm-incident-continue-button"
      data-cy="confirm-incident-modal"
    />
  );
};
